'use client';

import {
  BodyLink,
  type BodyLinkProps,
} from '@jouzen/ecom-components/v3/BodyLink';
import type { JSX } from 'react';

const PrivacyPolicyLink = ({
  children,
  ...props
}: BodyLinkProps): JSX.Element => {
  return (
    <BodyLink
      color="inherit"
      href="https://ouraring.com/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children ?? 'privacy policy'}
    </BodyLink>
  );
};

export default PrivacyPolicyLink;
